const unwrapper = {
    unwrapCollection(model, key, resource) {
        let models;

        return new Promise((resolve, reject) => {


            // if the resource is embedded, return the array of models
            if (Array.isArray(resource)) {

                models = (Array.from(resource).map(service => new model(service)));
                resolve(models);

            } else if (resource.$has(key)) {
                resource.$get(key).then((items) => {
                        models = [];
                        for (const i of Array.from(items)) {
                            models.push(new model(i));
                        }
                        return resolve(models);
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            } else {
                reject();
            }

        });
    },

    unwrapResource(model, resource) {
        return new model(resource);
    }
};

export {
    unwrapper
}